import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

interface ErrorChartProps {
  relativeError: number;
  absoluteError: number;
  significantDigits: number;
}

export const ErrorChart: React.FC<ErrorChartProps> = ({ relativeError, absoluteError, significantDigits }) => {
  const errorData = [
    { name: '相対誤差 (%)', value: relativeError, color: '#ef4444' },
    { name: '絶対誤差', value: absoluteError, color: '#3b82f6' }
  ];

  const precisionData = [
    { name: '有効数字', value: significantDigits, color: '#10b981' },
    { name: '精度', value: 100 - relativeError, color: '#f59e0b' }
  ];

  return (
    <div className="space-y-6">
      <div className="card">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">誤差解析</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="text-sm font-medium text-gray-700 mb-2">相対誤差と絶対誤差</h4>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={errorData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip 
                  formatter={(value: number) => [value.toFixed(4), '']}
                  labelStyle={{ color: '#374151' }}
                />
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </div>
          
          <div>
            <h4 className="text-sm font-medium text-gray-700 mb-2">精度分析</h4>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={precisionData}
                  cx="50%"
                  cy="50%"
                  innerRadius={40}
                  outerRadius={80}
                  paddingAngle={5}
                  dataKey="value"
                >
                  {precisionData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip 
                  formatter={(value: number) => [value.toFixed(2), '']}
                  labelStyle={{ color: '#374151' }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
        
        <div className="mt-4 grid grid-cols-2 gap-4">
          <div className="text-center p-3 bg-red-50 rounded-lg">
            <div className="text-2xl font-bold text-red-600">{relativeError.toFixed(4)}%</div>
            <div className="text-sm text-red-700">相対誤差</div>
          </div>
          <div className="text-center p-3 bg-blue-50 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">{absoluteError.toExponential(2)}</div>
            <div className="text-sm text-blue-700">絶対誤差</div>
          </div>
        </div>
      </div>
    </div>
  );
}; 